import { Box } from "@mui/material";
import { QRCode } from "react-qrcode-logo";
import { useSelector } from "react-redux";
import { Root } from "../state/types";
import SaveQrCode from "./SaveQrCode";


const QrCode = () => {
    const qrData = useSelector((state: Root) => state.qrData);

    return(
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            <QRCode
                id="QRCode"
                size={256}
                value={qrData.qrText}
                logoImage={qrData.logoSrc}
                logoPadding={10}
                fgColor={qrData.qrColour}
                bgColor={qrData.bgColour}
            />
            <SaveQrCode />
        </Box>
    )
}

export default QrCode;